import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=21862c43&"
import script from "./SendMessageForm.vue?vue&type=script&lang=js&"
export * from "./SendMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendMessageForm.vue"
export default component.exports